<div class="container-panel">
  <p-panel class="container-panel" [showHeader]="false" >
    <div class="container-panel" [innerHTML]="politica?.texto"></div>
    <p-footer>
        Data de registro: {{ politica?.dataAlteracao | myDate }}, versão: {{ politica?.versao }}
    </p-footer>
  </p-panel>
  </div>